import { useMemo } from 'react';

import { useToggle } from '@common/hooks';
import { useCatalogProductIdParams } from '@domains/pdp-common';

import { useContactInfo } from '../queries/useContactInfoQuery';

export const useSellerInfoService = () => {
  const country = 'KR';

  const [isOpened, toggle] = useToggle(false);

  const param = useCatalogProductIdParams();
  const { shop } = useContactInfo(param);

  const sellerInfo = useMemo(() => {
    const { business_license, shop_business_info, customer_center_tel, main_contact, online_sales_license } = shop;
    return {
      // 법적 고지가 필요한 필수 정보
      company_name: business_license?.company_name,
      representative_name: business_license?.representative_name,
      company_address: business_license?.company_address,
      registration_number: business_license?.registration_number,
      customer_center_tel: country !== 'KR' ? customer_center_tel : null,
      company_email: country !== 'KR' ? main_contact?.email : null,
      online_sales_license_number: online_sales_license?.license_number ?? null,

      // 비필수 정보
      ...(shop_business_info?.seller_info ?? {
        terms_of_use_policy_url: '',
        privacy_policy_url: '',
        kakao_cs_url: null,
        naver_cs_url: null,
      }),
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shop]);

  return { country, sellerInfo, isOpened, toggle, isHide: !shop.business_license };
};
